import { Link, useLocation } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../hooks";
import { useGetBillingSummaryQuery } from "../redux/services/billing/billingApi";

/**
 * Global banner shown when the tenant subscription needs billing attention
 * (for example past-due or canceled). Hidden on Settings > Billing itself.
 */
export function BillingAttentionBanner() {
  const { user } = useAuth();
  const location = useLocation();

  const canViewBilling =
    user?.authority === "owner" ||
    user?.type === "admin" ||
    user?.authority === "superAdmin";

  const { data } = useGetBillingSummaryQuery(
    { limit: 1 },
    { skip: !canViewBilling }
  );

  const requiresAttention = Boolean(
    data?.billing?.entitlements?.requiresBillingAttention
  );
  const isBillingPage = location.pathname.startsWith("/settings/billing");

  if (!requiresAttention || isBillingPage) {
    return null;
  }

  return (
    <div
      className="border-b border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900"
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-2">
          <ExclamationTriangleIcon
            className="mt-0.5 h-5 w-5 flex-shrink-0 text-rose-600"
            aria-hidden="true"
          />
          <div>
            <p className="font-semibold">Payment needed</p>
            <p className="text-rose-800">
              We could not collect your latest subscription payment. Update your
              payment method to avoid interruption.
            </p>
          </div>
        </div>
        <Link
          to="/settings/billing"
          className="inline-flex items-center justify-center rounded-lg bg-rose-600 px-3 py-2 text-sm font-semibold text-white hover:bg-rose-700"
        >
          Update billing
        </Link>
      </div>
    </div>
  );
}

export default BillingAttentionBanner;
